Vue.component('search-boxes-item', {
	props: ['item'],
	template: '#vue-search-boxes-item',
	data: function () {
		return {
			srcset: {},
			detailsCeo: false,
			imgSrcsetL: false,
		}
	},
	created: function () {
		const self = this;

		if (typeof config["seo"] !== "undefined" && typeof config["seo"]['details-ceo'] !== "undefined") {
			self.detailsCeo = config["seo"]['details-ceo'];
		}
		if (typeof config["components"]["search-boxes-item"] !== "undefined" && typeof config["components"]["search-boxes-item"]["srcset-l"] !== "undefined") {
			self.imgSrcsetL = config["components"]["search-boxes-item"]["srcset-l"];
		}

		let srcset = {};
		if (typeof self.item.img2 !== 'undefined' && self.item.img2 !== null && self.item.img2 !== '') {
			//srcset.s = self.item.img2.replace(/\.([^\.]*)$/,'s.$1');
			srcset.l = self.item.img2.replace(/\.([^\.]*)$/, 'l.$1');
		}
		self.srcset = srcset;
	}
});

Vue.component('search-boxes-section', {
	props: ['section', 'section_name'],
	template: '#vue-search-boxes-section'
});

Vue.component('search-boxes', {
	template: '#vue-search-boxes',
	data: function () {
		return {
			show: true,
			listItems: [],
			noOffers: false
		}
	},
	created: function () {
		this.getBoxes();
	},
	methods: {
		showBoxes: function () {
			this.show = true;
		},
		hideBoxes: function () {
			this.show = false;
		},
		getBoxes: function () {
			const self = this;
			$.post("/back/search/SearchBoxes.php", {}, function (result, textStatus) {
				if (result.length == 0) {
					self.noOffers = true;
				} else {
					self.noOffers = false;
					self.listItems = result;
				}
			}, "json");
		}
	}
});

Vue.component('carousel', {
	template: '#vue-carousel',
	data: function () {
		return {
			elementHandle: 'carousel_' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
		}
	},
	props: {
		items: { default: 3 },
		margin: { default: 30 },
		loop: { default: false },
		rewind: { default: true },
		center: { default: false },
		nav: { default: true },
		navText: {
			default: function () {
				return ["‹", "›"]
			}
		},
		dots: { default: false },
		autoplay: { default: true }, // true
		autoplaySpeed: { default: 700 },
		autoplayTimeout: { default: 10000 },
		autoplayHoverPause: { default: false }, // dla 'true' jest bug: mimo "autoplay" 'false' startuje autoplay
		mouseDrag: { default: true },
		touchDrag: { default: true },
		pullDrag: { default: true },
		freeDrag: { default: false },
		dragEndSpeed: { default: 600 },
		stagePadding: { default: 0 },
		autoWidth: { default: false },
		autoHeight: { default: false },
		responsive: {
			default: function () { //{0: { items: 1 }, 600: { items: 2 }, 1000: { items: 3 }, 1520: { items: 4 }}
				return {
					0: { items: 1 },
					600: { items: 2 },
					1000: { items: 3 }
				}
			}
		},
		lazyLoad: { default: true },
		lazyLoadEager: { default: 0 }
	},
	mounted: function () {
		const self = this;
		loadScript('/js/owl.carousel.min.js', function() {
			if (window.innerWidth <= 991) {
				self.lazyLoadEager = 0;
			}
			$('#' + self.elementHandle).owlCarousel({
				items: self.items,
				slideBy: 'page',
				margin: self.margin,
				loop: self.loop,
				rewind: self.rewind,
				center: self.center,
				nav: self.nav,
				navText: self.navText,
				dots: self.dots,
				autoplay: self.autoplay,
				autoplaySpeed: self.autoplaySpeed,
				autoplayTimeout: self.autoplayTimeout,
				autoplayHoverPause: self.autoplayHoverPause,
				mouseDrag: self.mouseDrag,
				touchDrag: self.touchDrag,
				pullDrag: self.pullDrag,
				freeDrag: self.freeDrag,
				dragEndSpeed: self.dragEndSpeed,
				stagePadding: self.stagePadding,
				autoWidth: self.autoWidth,
				autoHeight: self.autoHeight,
				responsive: self.responsive,
				lazyLoad: self.lazyLoad,
				lazyLoadEager: self.lazyLoadEager
			});
			$('#' + self.elementHandle + ' .oferta-box a.to-offer-details').hover(
				function () { $(self).closest(".oferta-box").find('a.to-offer-details').addClass('hover') },
				function () { $(self).closest(".oferta-box").find('a.to-offer-details').removeClass('hover') }
			);
		});
	}
});